const getGoogleMapsAddress = (lat, long) => `http://www.google.com/maps/place/${lat},${long}`;

export default getGoogleMapsAddress;
